/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrowthGalleryDto } from '../../models/growth-gallery-dto';
import { GrowthGalleryUpdateDto } from '../../models/growth-gallery-update-dto';

export interface GrowthGalleryControllerUpdate$Params {
  id: string;
      body: GrowthGalleryUpdateDto
}

export function growthGalleryControllerUpdate(http: HttpClient, rootUrl: string, params: GrowthGalleryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthGalleryDto>> {
  const rb = new RequestBuilder(rootUrl, growthGalleryControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrowthGalleryDto>;
    })
  );
}

growthGalleryControllerUpdate.PATH = '/api/growth-galleries/{id}';
